import api from 'app/api';
import getAll from './get-products';
import getAllWithJoin from './get-products-with-join';
import addProduct from './add-product';
import editProduct from './edit-product';
import getProductWithDocument from './get-product-with-document';
import getProductNestedProducts from './get-product-nested-products';

export const productsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getProducts: getAll(builder),
        getProductsWithJoin: getAllWithJoin(builder),
        addProduct: addProduct(builder),
        editProduct: editProduct(builder),
        getProductWithDocument: getProductWithDocument(builder),
        getProductNestedProducts: getProductNestedProducts(builder),
    }),
});

export const {
    useGetProductsWithJoinQuery,
    useAddProductMutation,
    useEditProductMutation,
    useGetProductWithDocumentQuery,
    useGetProductNestedProductsQuery,
    useGetProductsQuery,
} = productsApi;
